import AppointmentsService from "./appointments-service";
import Utils from "./utils";
import Modal from "./modal";

export default class TermsModal extends Modal {

  #title;
  #termsAccepted = false;
  #$container;

  constructor() {
    super();
    this.#title = "Terms and conditions";
    this.#$container = this.#getContent();
  }

  init() {
    this.setContent(this.#title, this.#$container);
  }

  async open(appointmentId) {
    this.#termsAccepted = false;

    let content;
    try {
      content = await AppointmentsService.getTerms();
    } catch (errResp) {
      // If no booking terms found, auto accept.
      if (errResp.status == 404) {
        this.#acceptTerms();
        return;
      }

      // Otherwise handle the error as usual.
      throw errResp;
    }

    await super.open();
    this.setContent(this.#title, this.#$container.append(content));
    this.#interceptSubmit(appointmentId);
  }

  async requestAcceptance(appointmentId) {
    await this.open(appointmentId);

    try {
      await this.#awaitAcceptance();
    } catch (error) {
      if (error.message === "Aborted") {
        error.message = "Booking terms closed.";
      }

      throw error;
    } finally {
      await this.close();
    }

    // Booking terms accepted
  }

  #interceptSubmit(appointmentId) {
    $("#terms-form").off("submit").on("submit", async (e) => {
      e.preventDefault();

      await AppointmentsService.acceptBookingTerms(appointmentId);
      await this.#acceptTerms();
    });
  }

  async #acceptTerms() {
    this.#termsAccepted = true;
    this.eventTarget.triggerHandler("accept");
  }

  async #awaitAcceptance() {
    if (this.#termsAccepted) {
      return Promise.resolve();
    }

    return Utils.promisifyEvent(this.eventTarget, "accept", this.abortController.signal);
  }

  #getContent() {
    return $(`<div id="content" class="row p-3"></div>`);
  }
}